import React from 'react';

export const UnboxingMsg = ({
  status = '', tx = '', user = '', nftId,
  setLoading = () => {}, errTransfer, seconds,
}) => {
  let msg;
  switch (status) {
    case 'init': {
      msg = <div style={{ padding: '20px 5px' }}>
          <b>Unboxing in progress.</b> Please <b style={{ color: 'yellow' }}>
            DO NOT CLOSE OR MINIMIZE THIS WINDOW
          </b> until complete! &nbsp; <sub>(takes about 1 min)</sub>
        </div>;
      break;
    }
    case 'errorTransferAndScan': {
      const errMsg = Array.isArray(errTransfer) ? errTransfer.join('; ') : errTransfer;
      msg = <div className="pad15" style={{ color: 'red' }}>
        <span onClick={() => setLoading({ value: false })} style={{ cursor: 'pointer' }}>
          ❌
        </span>
        &nbsp; UNBOXING of pack {nftId} FAILED. Please make sure that your <a href={`https://hiveblocks.com/@${user}`} target="_blank" rel="noreferrer">
          transfer</a> was successful.
        <br/>{tx && <p><sub className="text-white">Transaction: &nbsp; <sub><a href={`https://hiveblocks.com/tx/${tx}`} target="_blank" rel="noreferrer">
          {tx}</a></sub></sub></p>}
        <br/>{errTransfer && <p style={{ color: 'yellow' }}>Error: &nbsp; <i>{errMsg}</i></p>}
      </div>;
      break;
    }
    case 'errorClaim': {
      const errMsg = Array.isArray(errTransfer) ? errTransfer.join('; ') : errTransfer;
      msg = <div className="pad15" style={{ color: 'red' }}>
        <span onClick={() => setLoading({ value: false })} style={{ cursor: 'pointer' }}>
          ❌
        </span>
        &nbsp; UNBOXING of pack {nftId} FAILED. Please reach out to our mods to receive your NFTs.
        <br/>{tx && <p><sub className="text-white">Transaction: &nbsp; <sub><a href={`https://hiveblocks.com/tx/${tx}`} target="_blank" rel="noreferrer">
          {tx}</a></sub></sub></p>}
        <br/>{errTransfer && <p style={{ color: 'yellow' }}>Error: &nbsp; <i>{errMsg}</i></p>}
      </div>;
      break;
    }
    case 'success': {
      msg = <div className="pad15" style={{ color: 'lightgreen' }}>
        ✔️ UNBOXING COMPLETED. LFG!!
        <br/><p><sub className="text-white">Transaction: &nbsp; <sub><a href={`https://hiveblocks.com/tx/${tx}`} target="_blank" rel="noreferrer">
          {tx}</a> &nbsp; (unboxing took {seconds.toFixed(0)}s)</sub></sub>
        </p>
      </div>;
      break;
    }
    default: break;
  }
  return <p className="pad10 text-white text-center unboxing-wip">{msg}</p>;
};
